import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PhotovoltaikPage = lazy(() => import('../pages/services/photovoltaik/page'));
const AlarmanlagenPage = lazy(() => import('../pages/services/alarmanlagen/page'));
const BlitzschutzPage = lazy(() => import('../pages/services/blitzschutz/page'));
const ElektroinstallationenPage = lazy(() => import('../pages/services/elektroinstallationen/page'));
const BeleuchtungPage = lazy(() => import('../pages/services/beleuchtung/page'));
const NotdienstPage = lazy(() => import('../pages/services/notdienst/page'));
const WartungPage = lazy(() => import('../pages/services/wartung/page'));
const BeratungPage = lazy(() => import('../pages/services/beratung/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/leistungen/photovoltaik',
    element: <PhotovoltaikPage />,
  },
  {
    path: '/leistungen/alarmanlagen',
    element: <AlarmanlagenPage />,
  },
  {
    path: '/leistungen/blitzschutz',
    element: <BlitzschutzPage />,
  },
  {
    path: '/leistungen/elektroinstallationen',
    element: <ElektroinstallationenPage />,
  },
  {
    path: '/leistungen/beleuchtung',
    element: <BeleuchtungPage />,
  },
  {
    path: '/service/notdienst',
    element: <NotdienstPage />,
  },
  {
    path: '/service/wartung',
    element: <WartungPage />,
  },
  {
    path: '/service/beratung',
    element: <BeratungPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
